export default __webpack_public_path__ + "static/media/no-data.bf216154.svg";